import dayjs from 'dayjs';
import { ICustomer } from 'app/shared/model/customer.model';
import { IEmployee } from 'app/shared/model/employee.model';
import { RelationReportMethod } from 'app/shared/model/enumerations/relation-report-method.model';
import { RelationIncidentMethod } from 'app/shared/model/enumerations/relation-incident-method.model';
import { RelationStatusMethod } from 'app/shared/model/enumerations/relation-status-method.model';

export interface IRelationCustomer {
  id?: number;
  type?: string | null;
  title?: string | null;
  reportType?: keyof typeof RelationReportMethod | null;
  incidentType?: keyof typeof RelationIncidentMethod | null;
  channel?: string | null;
  status?: keyof typeof RelationStatusMethod | null;
  description?: string | null;
  updateDate?: dayjs.Dayjs | null;
  createDate?: dayjs.Dayjs | null;
  contactRmsId?: number | null;
  customer?: ICustomer | null;
  owner?: IEmployee | null;
}

export const defaultValue: Readonly<IRelationCustomer> = {};
